/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { Button, Divider, Image } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import store from "assets/img/store.png";
import arrowDown from "assets/img/arrow-down.png";
import cartIcon from "assets/img/cart.png";
import logo from "assets/img/logo-icon.png";
import { getNotificationCount } from "reducers/notifications";
import SearchProducts from "./SearchProducts";
import MobileCategoryMenu from "./MobileCategoryMenu";
import { appRoutesConst, ManageWholesalerLink } from "app/navigation";
import DrawerMenu from "components/menu/DrawerMenu";
import { GAMenuDrawer } from "hooks/googleAnalyticsHooks";
import ApprovedWholesalerListItem from "components/wholesalers/ApprovedWholesalerListItem";
/* Project Import will be here */

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showWholesaler: false,
      mobileMenu: false,
      isShowDrawerMenu: false,
      isAddToHomeScreenAvailable: true
    };

    /* Get the notification count to be displayed in the bell icon */
    this.props.actions.getNotificationCount();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  drawerMenuClose = () => {
    this.setState({
      isShowDrawerMenu: false
    });
  }

  openDrawerMenu = () => {
    /* Do not open the drawer menu when the user is in cart page */
    if (this.props.router.location.pathname !== appRoutesConst.orderSummary) {
      this.setState({ isShowDrawerMenu: true });

      /* GA - Track menu drawer initiation  */
      if (window.isEnableGA)
        GAMenuDrawer();
    }
  }

  toggleWholesaler = () => {
    this.setState({
      showWholesaler: !this.state.showWholesaler
    });
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.state.showWholesaler)
        this.setState({ showWholesaler: false });
    }
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  toggleMobileMenu = () => {
    this.setState({ mobileMenu: !this.state.mobileMenu });
  };

  renderWholesalerMenu = () => {
    const { selectedWholesaler, wholesalers, translate } = this.props;

    return (
      selectedWholesaler && wholesalers.data.length > 0 && (
        <li className="nav-item mr-24 navlink--border-right">
          <div
            className="nav-link d-flex align-items-center cursor-pointer color-white"
            onClick={(e) => {
              e.preventDefault();
              this.toggleWholesaler();
            }}
          >
            <img src={store} alt="store" className="mr-5 mt-minus-3" />
            <span className="nav-agency-name"> {selectedWholesaler.dName}</span>
            <img alt="" className="mt-minus-3" src={arrowDown} />
          </div>

          <div
            style={{ display: this.state.showWholesaler ? "block" : "none" }}
            className="dropdown-menu dropdown-menu-right account--dropdown whole-seller__drop p-3"
          >
            <ApprovedWholesalerListItem
              translate={translate}
              wholesaler={selectedWholesaler}
              isFromHeader={true}
            />

            {this.props.appSettings.isEnableManageDistributors &&
              <React.Fragment>
                <Divider />

                <div className="text-center">
                  <ManageWholesalerLink>
                    <Button type="link" onClick={this.toggleWholesaler}>
                      {this.props.translate("common.links.manageDistributors")}
                    </Button>
                  </ManageWholesalerLink>
                </div>
              </React.Fragment>
            }
          </div>
        </li>
      )
    );
  };

  enableMenu = () => {
    const { survey, router } = this.props;
    return router.location.pathname !== appRoutesConst.orderSummary && !survey.surveyNotification.disableHeader;
  };

  render() {
    const { cart, notifications, translate, appSettings, localStore } = this.props;

    /* Check for token availability */
    if (!localStore.token) {
      return "";
    }

    return (
      <React.Fragment>
        <header className="header header-shadow">
          <nav className="navbar navbar-expand-lg nav-md">
            {(this.enableMenu()) &&
              <div className="nav-link nav-link-drawer-menu-padding mt-1">
                <i onClick={this.openDrawerMenu} className="fa fa-bars fa-lg fav-product-header-icon cursor-pointer" aria-hidden="true"></i>
              </div>
            }

            <div className="col-xs-6 col-sm-6 col-md-3">
              {(!this.enableMenu()) ?
                <div className="navbar-brand">
                  <Image
                    className="client-image-height"
                    src={`${window.logoUrl}headerlogo${window.logoIteration}.png`}
                    alt={translate("common.imageAlt.headerLogo")}
                    fallback={logo}
                    preview={false}
                  />
                </div>
                :
                <Link to={appSettings.isEnableHomePage ? appRoutesConst.home : appRoutesConst.productList} className="navbar-brand">
                  <Image className="client-image-height"
                    src={`${window.logoUrl}headerlogo${window.logoIteration}.png`}
                    alt={translate("common.imageAlt.headerLogo")}
                    fallback={logo}
                    preview={false}
                  />
                </Link>
              }
            </div>

            {this.enableMenu() &&
              <div className="col-xs-6 col-sm-6 col-md-9 pl-0">
                <ul
                  ref={this.setWrapperRef}
                  className="navbar-nav flex-row justify-content-end align-items-center"
                >
                  {/* TODO: Need to check and delete this logic */}
                  {this.renderWholesalerMenu()}

                  {(appSettings.isFavProductEnable) &&
                    <li className="nav-item mr-24">
                      <Link to={appRoutesConst.favProducts} className="nav-link">
                        <i className="fa fa-heart fa-lg" aria-hidden="true"></i>
                      </Link>
                    </li>
                  }

                  {(appSettings.isShowNotifications) &&
                    <li className="nav-item mr-24 cart__link--content">
                      <Link to={appRoutesConst.notification} className="nav-link">
                        <React.Fragment>
                          <i className="fa fa-bell fa-lg" aria-hidden="true"></i>

                          <div className="random--text">
                            <p>{notifications.count}</p>
                          </div>
                        </React.Fragment>
                      </Link>
                    </li>
                  }

                  <li className="nav-item mr-24 cart__link--content cart-icon-with-count">
                    <Link to={appRoutesConst.orderSummary} className="nav-link">
                      <React.Fragment>
                        <img src={cartIcon} alt="Cart" />

                        {!cart.isLoading && (
                          <div className="random--text">
                            <p>{(cart.ids.length + cart.freeProducts.length) || 0}</p>
                          </div>
                        )}
                      </React.Fragment>
                    </Link>
                  </li>

                  <li className="nav-item mr-24">
                    <SearchProducts />
                  </li>
                </ul>
              </div>}
          </nav>

          {/* Mobile header */}
          <MobileCategoryMenu openDrawerMenu={this.openDrawerMenu} translate={translate} />
        </header>

        {/* Menu drawer for both web and mobile */}
        <DrawerMenu isShowDrawerMenu={this.state.isShowDrawerMenu} drawerMenuClose={this.drawerMenuClose} />
      </React.Fragment >
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications,
  cart: state.cart,
  wholesalers: state.wholesalers,
  categoryMenu: state.categoryMenu,
  selectedWholesaler: state.localStore.selectedWholesaler,
  translate: getTranslate(state.locale),
  appSettings: state.appSettings,
  router: state.router,
  localStore: state.localStore,
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getNotificationCount
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);